import React, { useState, isValidElement } from "react";
import { MdArrowForwardIos } from "react-icons/md";
import cx from "classnames";
import ReactSelect from "react-select";
const Step = ({ step, startOpen }) => {
  const [show, setShow] = useState(startOpen || false);
  const { title, Body, image } = step;
  return (
    <div className="  max-md:ml-0 max-md:pb-2 border-t border-b  py-6 text-black">
      <div className=" flex items-center justify-between font-bold text-[18px]  antialiased max-md:text-[18px]">
        <h3 className=" ">{title}</h3>{" "}
        <div onClick={() => setShow(!show)}>
          <MdArrowForwardIos
            size={22}
            className={cx(" cursor-pointer transition-transform duration-200", {
              " rotate-90": show,
              "rotate-0": !show,
            })}
          />
        </div>
      </div>
      <div
        className={cx(
          "  text-[16px] transition-[grid-template-rows] antialiased duration-200 ease-in-out overflow-hidden grid",
          {
            " grid-rows-[0fr]": !show,
            " grid-rows-[1fr]": show,
          }
        )}
      >
        <div className=" overflow-hidden">
          <div className=" mt-4">
            <div className="text-black-1">
              <Body />
            </div>
            <div className=" h-[600px] max-sm:h-auto w-full mt-[40px]">
              <img
                src={image}
                alt="blockset-start-guid-img"
                className=" h-full w-full bg-contain max-sm:bg-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const Template = ({ title, guideSteps, types }) => {
  return (
    <section className=" m-auto pt-[75px] max-sm:pt-[40px] max-sm:px-6 pb-[150px]  items-center ">
      <div className=" max-w-[900px] mx-auto ">
        <div className={cx({ " justify-between flex items-center": !!types })}>
          <h3 className=" text-[28px] font-semibold text-black">{title}</h3>
          {!!types && (
            <ReactSelect
              options={types.options}
              value={types.select}
              isSearchable={false}
              classNames={{
                control: (base) =>
                  `!shadow-none flex-shrink-0 flex-grow !min-h-0  !rounded-lg hover:!border hover:!border-[#e5e7eb]`,
                menuList: () => " !p-[4px] !w-full !text-black ",
                option: () =>
                  "!rounded-lg !w-full !p-[6px_12px] mb-3 !last:mb-0 !bg-transparent hover:!bg-black-0.05",
              }}
              styles={{
                control: (css, state) => ({
                  ...css,
                  background: state.menuIsOpen
                    ? "rgba(0,0,0,0.05)"
                    : css.background,
                  borderColor: "#e5e7eb",
                }),
                option: (styles, { isDisabled }) => {
                  return {
                    ...styles,

                    color: isDisabled ? "rgba(0,0,0,.5)" : "black",
                    backgroundColor: isDisabled
                      ? "rgba(0,0,0,.05)"
                      : styles.backgroundColor,
                    cursor: isDisabled ? "not-allowed" : styles.cursor,
                  };
                },
              }}
              onChange={types.onSelectChange}
              formatOptionLabel={(data, option) => {
                return (
                  <div
                    className=" flex gap-3 cursor-pointer items-center "
                    key={data.id}
                  >
                    <div className=" text-[13px] ">
                      <div className=" flex items-center gap-x-3">
                        <img src={data.icon} className=" h-8 w-8" />{" "}
                        {data.label}
                      </div>
                    </div>
                  </div>
                );
              }}
            />
          )}
        </div>

        <div className=" mt-[30px]">
          {guideSteps.map((guide, i) => (
            <Step step={guide} key={i} startOpen={i === 0} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Template;
